<template>
  <v-container fluid class="project-site-page">
    <div v-if="cards.length > 0" class="project-site-list">
      <button
        v-for="card in cards"
        :key="card.projectID"
        type="button"
        class="project-card zoom"
        @click="routerPage(card)"
      >
        <img
          :src="langhamBuildingImage"
          alt=""
          class="project-card__building"
        />
        <img
          :src="langhamTextImage"
          :alt="card.projectName"
          class="project-card__text"
        />
      </button>
    </div>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import enurl from "@/api/environment";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ProjectSite",
  data() {
    return {
      url: enurl.apiUrl,
      urlReport: enurl.apiReport,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      reportMenu: [],
      reportMenuCarpark: [],
      MenuPermission: [],
      cards: [],
      model: null,
      cardsData: [],
      ProjectSiteList: [],
      langhamBuildingImage: require("@/assets/Langham-UI.png"),
      langhamTextImage: require("@/assets/Langham-text2.png"),
    };
  },
  
  async mounted() {
    await this.getDataProjectSiteFromRoleID();
  },

  computed: {},

  methods: {
    getDataProjectSiteFromRoleID() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getDataProjectSiteFromRoleID`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectSiteList = response.data.data;
            self.cards = self.ProjectSiteList.map((item) => ({
              ...item,
              src: self.getLogoImageSrc(item.logoImage),
              flex: 3,
            }));
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    getLogoImageSrc(logoImage) {
      if (!logoImage) {
        return require("@/assets/logoFS.svg");
      }

      const image = logoImage.trim();
      if (/^(data:image\/|https?:\/\/|\/)/i.test(image)) {
        return image;
      }

      if (image.indexOf("<svg") === 0 || image.indexOf("<?xml") === 0) {
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(image)}`;
      }

      return `data:${this.getLogoImageMimeType(image)};base64,${image}`;
    },

    getLogoImageMimeType(base64Image) {
      const image = base64Image.replace(/\s/g, "");

      if (image.indexOf("/9j") === 0) {
        return "image/jpeg";
      }

      if (image.indexOf("iVBORw0KGgo") === 0) {
        return "image/png";
      }

      try {
        const decodedImage = atob(image).trim().toLowerCase();
        if (
          decodedImage.indexOf("<svg") === 0 ||
          decodedImage.indexOf("<?xml") === 0
        ) {
          return "image/svg+xml";
        }
      } catch (error) {
        return "image/png";
      }

      return "image/png";
    },

    routerPage(page) {
      localStorage.setItem("ProjectSiteID", page.projectID);
      localStorage.setItem("ProjectSiteName", page.projectName);
      this.$router.push("/MainMenu");
    },
  },
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "Roboto", sans-serif;
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.project-site-page {
  width: 100%;
  min-height: calc(100vh - 140px);
  min-height: calc(100dvh - 140px);
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-site-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.project-card {
  width: min(397px, calc(100vw - 48px));
  aspect-ratio: 397 / 470;
  padding: clamp(64px, 11vw, 108px) clamp(28px, 5vw, 44px) 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  color: inherit;
  background-color: #ffffff;
  border: 1.5px solid #808080;
  border-radius: 10px;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.14);
  box-sizing: border-box;
  overflow: hidden;
}

.project-card__building {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.project-card__text {
  width: 100%;
  height: auto;
  margin-top: 20px;
  display: block;
  object-fit: contain;
}

.zoom {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.zoom:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.18);
}

.project-card:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 4px;
}

@media (max-width: 600px) {
  .project-site-page {
    min-height: calc(100vh - 120px);
    min-height: calc(100dvh - 120px);
    padding: 16px;
  }

  .project-site-list {
    gap: 16px;
  }

  .project-card {
    width: min(360px, calc(100vw - 32px));
    padding-bottom: 28px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .zoom {
    transition: none;
  }

  .zoom:hover {
    transform: none;
  }
}
.custom-red .v-input--selection-controls__input div {
  color: #6a1b9a;
}
</style>
